import { PaginationType } from "../../Types/APITypes";
import { Category, Post, PostComment } from "../../Types/Blogs";
import API from "./API";

class BlogAPI extends API {
  static get_categories = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/blog/categories?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""} `,
      true
    );
  };

  static add_category = (category: Category) => {
    return this.postRequest("manage/blog/categories/create", category, true);
  };

  static update_category = (category: Category) => {
    return this.putRequest(
      `manage/blog/categories/${category.id}/update`,
      category,
      true
    );
  };

  static delete_category = (category: Category) => {
    return this.deleteRequest(
      `manage/blog/categories/${category.id}/delete`,
      category,
      true
    );
  };

  static add_post = (post: Post) => {
    const formdata = new FormData();
    type postType = keyof Post;

    for (const key in post) {
      if (Object.prototype.hasOwnProperty.call(post, key)) {
        const element = post[key as postType];
        formdata.append(key, (element || "")?.toString());
      }
    }

    formdata.delete("poster");
    formdata.delete("poster_file");
    if (post.poster_file) formdata.append("poster", post.poster_file);

    return this.postFileRequest("manage/blog/posts/create", formdata, true);
  };

  static get_post = (id: number) => {
    return this.getRequest(`blog/posts/${id}/show`, true);
  };

  static get_single_post_comments = (id: number, pagination?: PaginationType) => {
    return this.getRequest(
      `manage/blog/posts/${id}/comments?page=${
        pagination?.current_page || 1
      }&per_page=${pagination?.per_page || 10}${
        pagination?.search_word ? `&query=${pagination.search_word}` : ""
      } `,
      true
    );
  };

  static update_post = (post: Post) => {
    const formdata = new FormData();
    type postType = keyof Post;

    for (const key in post) {
      if (Object.prototype.hasOwnProperty.call(post, key)) {
        const element = post[key as postType];
        formdata.append(key, (element || "")?.toString());
      }
    }

    formdata.delete("poster");
    formdata.delete("poster_file");
    if (post.poster_file) {
      formdata.append("poster", post.poster_file);
      return this.putFileRequest(
        `manage/blog/posts/${post.id}/update`,
        formdata,
        true
      );
    } else {
      const { poster, ...rest } = post;
      return this.putRequest(`manage/blog/posts/${post.id}/update`, rest, true);
    }
  };

  static get_posts = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/blog/posts?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""} `,
      true
    );
  };

  static update_post_status = (id: number, new_status: boolean) => {
    let link = "";

    switch (new_status) {
      case true:
        link = "publish";
        break;
      case false:
        link = "draft";
        break;

      default:
        break;
    }

    return this.patchRequest(`manage/blog/posts/${id}/${link}`, {}, true);
  };

  static delete_post = (id: number) => {
    return this.deleteRequest(`manage/blog/posts/${id}/delete`, {}, true);
  };

  static get_post_comments = (pagination?: PaginationType) => {
    return this.getRequest(
      `manage/blog/comments?page=${pagination?.current_page || 1}&per_page=${
        pagination?.per_page || 10
      }${pagination?.search_word ? `&query=${pagination.search_word}` : ""} `,
      true
    );
  };

  static delete_post_comment = (comment: PostComment) => {
    return this.deleteRequest(
      `manage/blog/posts/${comment.blog_post_id}/comments/${comment.id}/delete`,
      {},
      true
    );
  };

  static disable_post_comment = (comment: PostComment) => {
    return this.patchRequest(
      `manage/blog/posts/${comment.blog_post_id}/comments/${comment.id}/disable`,
      {},
      true
    );
  };

  static publish_post_comment = (comment: PostComment) => {
    return this.patchRequest(
      `manage/blog/posts/${comment.blog_post_id}/comments/${comment.id}/publish`,
      {},
      true
    );
  };

  static update_post_comment = (comment: PostComment) => {
    return this.putRequest(
      `manage/blog/posts/${comment.blog_post_id}/comments/${comment.id}/update`,
      comment,
      true
    );
  };
}

export default BlogAPI;
